import { useState } from "react";
import { ReminderElipses } from "../lead-inventory/icons";
import FileUploadComponent from "./TestSectionUpload";
import { useFetchExistingFiles } from "@/api/files/useFetchExistingFiles";
import ShowDocuments from "./ShowDocuments";
import AdditionalDetails from "../onboarding-documents/AdditionalDetailsNew";
import { useGetAccountOwner } from "@/api/auth/useGetAccountOwner";
import { correlationHeaders } from "@/utils/correlationId";

export default function DocumentsTab({ leadID, opprefID, funnel }) {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const fromOpp = true

  const accountOwner = useGetAccountOwner({leadID: leadID});

  // State: follow old (including insurance toggle state)
  const [showLoaDocs, setShowLoaDocs] = useState(false);
  const [showIdDocs, setShowIdDocs] = useState(false);
  const [showOthersDocs, setShowOthersDocs] = useState(false);
  const [showInsuranceDocs, setShowInsuranceDocs] = useState(false);

  const toggleLoaDocs = () => setShowLoaDocs(!showLoaDocs);
  const toggleIdDocs = () => setShowIdDocs(!showIdDocs);
  const toggleOthersDocs = () => setShowOthersDocs(!showOthersDocs);
  const toggleInsuranceDocs = () => setShowInsuranceDocs(!showInsuranceDocs);

  const [isLoaModalOpen, setIsLoaModalOpen] = useState(false);
  const [isIdModalOpen, setIsIdModalOpen] = useState(false);
  const [isOthersModalOpen, setIsOthersModalOpen] = useState(false);

  const openLoaModal = () => setIsLoaModalOpen(true);
  const closeLoaModal = () => setIsLoaModalOpen(false);
  const openIdModal = () => setIsIdModalOpen(true);
  const closeIdModal = () => setIsIdModalOpen(false);
  const openOthersModal = () => setIsOthersModalOpen(true);
  const closeOthersModal = () => setIsOthersModalOpen(false);

  const refreshFiles = () => setRefreshTrigger((prev) => prev + 1);

  // Data fetching: follow new (hook) but keep insuranceFiles like old
  const {
    idFileCount = 0,
    loaFileCount = 0,
    othersFileCount = 0,
    idFile = [],
    loaFile = [],
    othersFile = [],
    insuranceFiles = [],
  } = useFetchExistingFiles(leadID, opprefID, refreshTrigger);

  // Section title: follow old
  const sectionTitle =
    funnel === "Re-KYC"
      ? "Re-KYC Email"
      : funnel === "Referral"
      ? "Referral Documents"
      : funnel === "Financing"
      ? "Financing Documents"
      : funnel === "InsuranceRenewal"
      ? "Renewal Insurance Documents"
      : "Insurance Documents";

      const handlePreviewPdf = async (file) => {
        try {
          // 1) BEST PATH: If presigned S3 URL exists (insurance files), open directly
          if (file.url) {
            window.open(file.url, "_blank", "noopener,noreferrer");
            return;
          }
      
          // 2) FALLBACK PATH: Use /api/view_pdf -> blob streaming
          const API_BASE = import.meta.env.VITE_BASE_URL;
          const token = localStorage.getItem("token");
      
          if (!token) {
            console.error("No token found, cannot preview PDF");
            return;
          }
      
          const res = await fetch(
            `${API_BASE}/api/view_pdf?key=${encodeURIComponent(file.key)}&disposition=inline`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                ...correlationHeaders(),
              },
            }
          );
      
          if (!res.ok) {
            console.error("Failed to preview PDF:", res.status, await res.text());
            return;
          }
      
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          window.open(url, "_blank");
        } catch (err) {
          console.error("Error previewing PDF:", err);
        }
      };

  return (
    <>
    <div className="p-4">
      <div className="p-4 rounded-lg bg-white shadow-md">
        <h1 className="p-4 text-xl font-bold">{sectionTitle}</h1>

        {/* LOA / ID / Others (hidden for insurance funnels, like old) */}
        {/* {!((funnel?.toLowerCase?.() || "").includes("insurance")) && (
          <>
            <DocumentSection
              title="Letter of Authorization"
              fileCount={loaFileCount}
              files={loaFile}
              showDocs={showLoaDocs}
              toggleDocs={toggleLoaDocs}
              onUploadClick={openLoaModal}
            />

            <DocumentSection
              title="Identification Documents"
              fileCount={idFileCount}
              files={idFile}
              showDocs={showIdDocs}
              toggleDocs={toggleIdDocs}
              onUploadClick={openIdModal}
            />

            <DocumentSection
              title="Others"
              fileCount={othersFileCount}
              files={othersFile}
              showDocs={showOthersDocs}
              toggleDocs={toggleOthersDocs}
              onUploadClick={openOthersModal}
            />
          </>
        )} */}

        {/* Insurance Policies + Claims Section: follow old */}
        {(funnel?.toLowerCase?.() || "").includes("insurance") && (
          <>
            <div className="p-4 border-b flex flex-row gap-4 items-center justify-between">
              <div className="flex flex-row gap-4 pt-2 mt-2 items-center">
                <a className="font-bold">Insurance Documents</a>
                <img
                  src={ReminderElipses}
                  alt="Reminder Elipses"
                  className="w-2 h-2"
                />
                <p className="text-[#94A3B8]">
                  {insuranceFiles?.length || 0} Document(s)
                </p>
              </div>
            </div>

            {insuranceFiles?.length > 0 ? (
              <div className="p-4 space-y-3">
                {insuranceFiles.map((file, index) => {
                  const API_BASE = import.meta.env.VITE_BASE_URL;
                  const isClaim = file.key.includes("/claims/");
                  return (
                    <div
                      key={index}
                      className="bg-[#F1F5F9] p-3 rounded flex justify-between items-center"
                    >
                      <div>
                      <button
                        onClick={() => handlePreviewPdf(file)}
                        className="font-bold text-sm underline"
                        type="button"
                        >
                        {file.file_name}
                        </button>
                        <p className="text-xs text-[#94A3B8]">
                          {isClaim ? "Claim Document" : "Policy Document"}
                        </p>
                      </div>
                      <div className="space-x-2">
                      <button
                        onClick={() => handlePreviewPdf(file)}
                        className="mr-2 underline text-sm"
                        type="button"
                        >
                        Preview
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="p-4 text-sm text-gray-500">
                No insurance policy or claim documents found.
              </div>
            )}
          </>
        )}
      </div>

      {/* Modals: follow old reusable UploadModal */}
      {/* {isLoaModalOpen && (
        <UploadModal
          title="Letter of Authorization"
          onClose={closeLoaModal}
          docType="loa"
          leadID={leadID}
          files={loaFile}
          fileCount={loaFileCount}
          onUploadSuccess={refreshFiles}
        />
      )} */}
      {/* {isIdModalOpen && (
        <UploadModal
          title="Identification Documents"
          onClose={closeIdModal}
          docType="id"
          leadID={leadID}
          files={idFile}
          fileCount={idFileCount}
          onUploadSuccess={refreshFiles}
        />
      )}
      {isOthersModalOpen && (
        <UploadModal
          title="Others"
          onClose={closeOthersModal}
          docType="misc"
          leadID={leadID}
          files={othersFile}
          fileCount={othersFileCount}
          onUploadSuccess={refreshFiles}
        />
      )} */}
    </div>
    { funnel === 'Re-KYC' && (
      <AdditionalDetails leadOwner = {accountOwner} leadID = {leadID} fromOpp={fromOpp}/>
    )}
    </>
  );
}

// Reusable document section: follow old, but use <img> instead of <Image>
function DocumentSection({
  title,
  fileCount,
  files,
  showDocs,
  toggleDocs,
  onUploadClick,
}) {
  return (
    <div className="p-4 border-b flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          <a className="font-bold">{title}</a>
          <img
            src={ReminderElipses}
            alt="Reminder Elipses"
            className="w-2 h-2"
          />
          <p className="text-[#94A3B8]">{fileCount} Document(s)</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onUploadClick}
            className="font-bold border w-auto p-2 rounded-full border-[#F7E21E] bg-[#F7E21E] text-[#1E293B] hover:bg-blue-500"
          >
            Upload
          </button>
          <button
            onClick={toggleDocs}
            className="rounded-full border p-1 border-[#1E293B] hover:bg-gray-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className={`size-6 transation-transform ${
                showDocs ? "rotate-90" : ""
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
        </div>
      </div>
      {showDocs && <ShowDocuments documents={files} fileCount={fileCount} />}
    </div>
  );
}

// Reusable upload modal: follow old, with <img> removed (only svg)
function UploadModal({
  title,
  onClose,
  docType,
  leadID,
  files,
  fileCount,
  onUploadSuccess,
}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white h-auto w-[60%] p-6 rounded-lg shadow-xl relative">
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          ✕
        </button>
        <FileUploadComponent
          docType={docType}
          title={title}
          leadID={leadID}
          onUploadSuccess={onUploadSuccess}
        />
        {fileCount > 0 ? (
          <ul className="mt-2 text-sm max-h-48 overflow-y-auto">
            {files.map((file, index) => (
              <li
                key={index}
                className="mb-4 p-4 bg-[#E2E8F0] rounded-lg flex flex-row gap-3 items-center relative"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="size-10"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                  />
                </svg>
                <span className="flex flex-col gap-1">
                  <p className="font-bold text-base">
                    {file.filename?.replace?.(".pdf", "") ||
                      file.filename ||
                      file.file_name}
                  </p>
                  <div className="text-xs text-[#94A3B8]">
                    {(file.filename || file.file_name || "")
                      .split(".")
                      .pop()}{" "}
                    — {((file.size || 0) / 1024).toFixed(2)} KB
                  </div>
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="flex text-sm text-gray-500 justify-center">
            No files found
          </p>
        )}
      </div>
    </div>
  );
}